import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import AddDomainDrawerContent from './AddDomainDrawerContent';

interface AddDomainDrawerProps {
  show: boolean;
  setShow: (show: boolean) => void;
  maxCompetitors?: number;
  /** Render above open modals (e.g. project setup). */
  stackAboveModal?: boolean;
}

const STACK_ABOVE_MODAL_Z = 1100;

const AddDomainDrawer = ({
  show,
  setShow,
  maxCompetitors = 1,
  stackAboveModal = false,
}: AddDomainDrawerProps) => {
  const [competitorsCount, setCompetitorsCount] = useState(0);

  return (
    <Offcanvas
      onShow={() => {
        const offcanvasElement = document.querySelector('.offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={() => {
        setShow(false);
        setCompetitorsCount(0);
      }}
      backdropClassName={stackAboveModal ? 'offcanvas-above-modal-backdrop' : undefined}
      style={{
        backgroundColor: 'var(--falcon-body-bg)',
        ...(stackAboveModal ? { zIndex: STACK_ABOVE_MODAL_Z } : {}),
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="m-0">افزودن دامنه جدید &nbsp;</div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pb-5 pt-0">
        <div className="mt-3"></div>
        <AddDomainDrawerContent
          setShow={setShow}
          competitorsCount={competitorsCount}
          setCompetitorsCount={setCompetitorsCount}
          maxCompetitors={maxCompetitors}
        />
      </Offcanvas.Body>

      <style>
        {`
          .offcanvas{
              width:500px !important;
              max-width:100% !important;
          }
          .offcanvas img {
              margin: 0 auto;
              max-width: 100%;
              height: auto;
              display: flex;
          }
          ${
            stackAboveModal
              ? `.offcanvas-above-modal-backdrop { z-index: ${STACK_ABOVE_MODAL_Z - 1} !important; }`
              : ''
          }
        `}
      </style>
    </Offcanvas>
  );
};

export default AddDomainDrawer;
